module.exports = function() {
  return new Worker(__webpack_public_path__ + "65dce5dd4304a5975704.worker.js");
};